import { loadModules } from 'esri-loader'

const actions = {   	

	labelRoomNumbers({rootState}) {
		//console.log("Apply Labels to RI Graphics")
		loadModules(['esri/graphic', 'esri/symbols/TextSymbol', 'esri/symbols/Font'])
  		.then(async ([Graphic, TextSymbol, Font]) => {

  			const roomnumberlabelsLayer = rootState.mapFunctions.stateMap.getLayer('roomnumberlabelslayer')
  			const roominteractivityLayer = rootState.mapFunctions.stateMap.getLayer('roominteractivitylayer')
		
			// Clear Layer		
			roomnumberlabelsLayer.clear()

			// Just leave if not using clientLabels
			//if (!rootState.mapUi.clientLabels) { return }

			// Scalable Fonts by zoom level (Zoom, Font).  19 does not work really.  too small.
			/*let scaledFontSize = {
			    "20": 6,
			    "21": 10, 
			    "22": 14,
			    "23": 18, 
			    "24": 20,
			    "25": 100,
			}*/

			let scaledFontSize = {
			    "20": 6,
			    "21": 8, 
			    "22": 8,
			    "23": 8, 
			    "24": 10,
			    "25": 10,
			    "26": 10,
			    "27": 10,
			    "28": 12,
			    "29": 12,
			    "30": 12,
			    "31": 14,
			    "32": 14,
			    "33": 16,

			}

			/*let allowedCharsPerWidthUnit = {
			    "20": .72,
			    "21": .6, 
			    "22": .35,
			    "23": .2, 
			    "24": 20,
			    "25": 100,
			}*/

			let allowedCharsPerWidthUnit = {
			    "20": .72,
			    "21": .65, 
			    "22": .62,
			    "23": .62, 
			    "24": .6,
			    "25": .6,
			    "26": .5,
			    "27": .5,
			    "28": .5,
			    "29": .3,
			    "30": .1,
			    "31": .1,
			    "32": .1,
			    "33": .1,
			}  // Smaller numbers are more permissive

			// Only execute if zoom was equal to one of the above.
			if (!scaledFontSize[rootState.mapFunctions.stateMap.getLevel()]) { return }

			//console.log("Zoom: ", rootState.mapFunctions.stateMap.getLevel())
			//console.log("Using Font Size: ", scaledFontSize[rootState.mapFunctions.stateMap.getLevel()])
			//console.log("Labeling ", rootState.mapLayers.roominteractivityLayer.graphics.length, "RI Graphics")
			
			// For each room interactivity graphic, add a room number label
			roominteractivityLayer.graphics.forEach((graphic) => {
				if (graphic && graphic.attributes && graphic.attributes['ROOMEXT.RM_ID']) {
					
					// Suppres display of circulation space labels, unless the user has set option true.
					if (rootState.ui.showAllRoomNumbers || graphic.attributes['ROOMEXT.RoomCategory'] != "Circulation Area") {

						// Find the center of each graphic
						const gExt = graphic.geometry.getExtent()
				    	const gCenter = gExt.getCenter()			
						const label = new TextSymbol()
							.setColor(rootState.ui.darkTheme ? [128,128,128] : [0,0,0])
							.setAlign(Font.ALIGN_START)
							.setFont(new Font(`${scaledFontSize[rootState.mapFunctions.stateMap.getLevel()]}pt`)
							.setWeight(Font.WEIGHT_NORMAL).setFamily('Comic Sans MS')) ; 
						label.setText(graphic.attributes['ROOMEXT.RM_ID'])

						// Create a new label graphic at the center of the room interactivity graphic, and add it to the layer.
						var labelGraphic = new Graphic(gCenter, label);

						// Stash room graphic in label for later convenience
						labelGraphic.roomGraphic = graphic

						// Add the graphic, if its too big, shrink the font by half.
						let labelChars = graphic.attributes['ROOMEXT.RM_ID'].length
						let allowedLabelWidth = labelChars * allowedCharsPerWidthUnit[rootState.mapFunctions.stateMap.getLevel()]
						//console.log(graphic.geometry.getExtent().getWidth(), allowedLabelWidth)
						if (graphic.geometry.getExtent().getWidth() > allowedLabelWidth ) {
							roomnumberlabelsLayer.add(labelGraphic);
						} else { 
							// Shrink the font in half.  This works sort of okay.  The other option is to not show.  Or refine further.
							//console.log("Downsize", labelGraphic)
							labelGraphic.symbol.font.size = labelGraphic.symbol.font.size/2
							roomnumberlabelsLayer.add(labelGraphic);				
						}
					}
				}
			})
		})
	},
}

export default {
	actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/mapLabels.js